<template>
  <div class="map-page">
    <SectionTitle title="时空轨迹" />
    <div class="map-page-body">
      <div v-if="mapData.length" class="map-page-body-inner">
        <div id="amap-container" class="map-page-body-content" />
        <div class="map-page-body-content-tool" :class="direction">
          <div v-if="mapData.length" class="map-page-body-content-tool__card">
            <div class="list">
              <div v-for="(item, index) in mapData" :key="index" class="list__item" :class="{'active': activeIndex === index}" @click="changeMap(index)">
                <div class="date">
                  <p>{{ item.property.year }}</p>
                  <p>{{ item.property.relation }}</p>
                </div>
                <p class="title">{{ item.property.name }}</p>
                <div class="types">
                  <span v-if="item.property.location" class="item">
                    <img src="@/assets/icon-event-list-place.svg">
                    <p class="text-line-1">{{ item.property.location }}</p>
                  </span>
                  <span v-if="item.property.participants" class="item">
                    <img src="@/assets/icon-event-list-orign.svg">
                    <p class="text-line-1">{{ item.property.participants }}</p>
                  </span>
                </div>
                <div v-if="item.property.image_set && item.property.image_set.length" class="imgs">
                  <img v-for="(img, imgIndex) in item.property.image_set" :key="imgIndex" :src="img.url" @click.stop="previewImage(img.url)">
                </div>
              </div>
            </div>
          </div>
          <div v-if="mapData.length" class="map-page-body-content-tool__buttons">
            <div class="btn" @click="prevMap">
              <img src="@/assets/icon-map-pre.svg">
              <p>上一个</p>
            </div>
            <div class="btn play" :class="{'active': isPlaying}" @click="playTrack">
              <img src="@/assets/icon-map-play.svg">
              <p>{{ isPlaying ? '暂停' : '播放' }}</p>
            </div>
            <div class="btn last" @click="nextMap">
              <img src="@/assets/icon-map-next.svg">
              <p>下一个</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="error">
        <p>暂无地图数据</p>
      </div>
    </div>

    <!-- 自定义信息框 -->
    <div
      v-if="infoWindowVisible"
      class="custom-info-window"
      :style="{
        left: infoWindowX + 'px',
        top: infoWindowY + 'px'
      }"
    >
      <div class="info-header">
        {{ currentMarkerData.title }}
        <button class="close-btn">×</button>
      </div>
      <div class="info-body">
        <p>经度：{{ currentMarkerData.lng }}</p>
        <p>纬度：{{ currentMarkerData.lat }}</p>
        <p>地址：{{ currentMarkerData.address }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from './SectionTitle.vue'
export default {
  name: 'SpaceMap',
  components: {
    SectionTitle
  },
  props: {
    mapData: {
      type: Array,
      default: () => []
    },
    direction: {
      type: String,
      default: 'right'
    },
    identitys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      speed: 4000,
      baseStepDistance: 2, // 基础每帧移动距离（从0.3→2米，核心提速）
      frameTimer: null,
      infoWindowVisible: false,
      infoWindowX: 0,
      infoWindowY: 0,
      currentMarkerData: {},
      filterId: '',
      // 地图实例
      map: null,
      // 标记点数组
      markers: [],
      // 轨迹线实例
      polyline: null,
      dynamicPolyline: null, // 动态绘制的轨迹线
      // 轨迹动画点
      animateMarker: null,
      isPlaying: false,
      activeIndex: -1,
      animateTimer: null,
      overlayView: null,
      defaultZoom: 14, // 默认缩放级别
      currentStep: 0, // 当前播放到的地点索引
      currentFrame: 0, // 当前帧（两点间的进度）
      animateSpeed: 80, // 动画速度（ms/步）
      stepCount: 50, // 两点间的步进数（平滑度）
      dynamicPath: [], // 动态轨迹线的路径
      baseStepSpeed: 0.2 // 基础步速（米/秒）
    }
  },
  watch: {
    mapData: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          // this.$nextTick(() => {
          //   this.createMapInstance()
          // })
        }
      },
      deep: true
    },
    identitys: {
      handler(newVal) {
        if (newVal) {
          this.filterId = ''
        }
      },
      deep: true
    }
  },
  created() {
  },
  methods: {
    switchMap(id) {
      this.filterId = id
      this.$emit('switchIdentity', id)
    },
    reloadMap() {
      this.createMapInstance()
    },
    createMapInstance() {
      // eslint-disable-next-line no-undef
      this.map = new AMap.Map('amap-container', {
        zoom: this.defaultZoom,
        center: [this.mapData[0].property.didianzuobiao.lng, this.mapData[0].property.didianzuobiao.lat],
        resizeEnable: true,
        mapStyle: `amap://styles/ac0cda86de4769e73166f0b5d9eb2082`
      })
      this.mapLoaded = true
      const that = this

      // 加载核心插件：几何计算（必加）+ 基础标注/线
      // eslint-disable-next-line no-undef
      AMap.plugin(
        ['AMap.Marker', 'AMap.InfoWindow', 'AMap.Polyline', 'AMap.GeometryUtil'],
        () => {
          that.initAllLocationMarkers() // 初始化所有地点静态标记
          that.changeMap(0)
        }
      )
    },

    /** 初始化所有地点的静态标记 */
    initAllLocationMarkers() {
      this.mapData.forEach((item) => {
        // eslint-disable-next-line no-undef
        const marker = new AMap.Marker({
          map: null,
          position: [item.property.didianzuobiao.lng, item.property.didianzuobiao.lat],
          title: item.property.event_summary,
          // eslint-disable-next-line no-undef
          icon: new AMap.Icon({
            // eslint-disable-next-line no-undef
            size: new AMap.Size(20, 30),
            image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png',
            // eslint-disable-next-line no-undef
            imageSize: new AMap.Size(20, 30)
          })
        })
        this.markers.push(marker)
        marker.on('click', () => {
          // // eslint-disable-next-line no-undef
          // const infoWindow = new AMap.InfoWindow({
          //   content: `<div style="padding: 8px;">${item.name}</div>`,
          //   // eslint-disable-next-line no-undef
          //   offset: new AMap.Pixel(0, -20)
          // })
          // infoWindow.open(this.map, marker.getPosition())
        })
      })
    },

    /**
     * 播放轨迹动画
     */
    playTrack() {
      // eslint-disable-next-line no-undef
      if (this.isPlaying) {
        this.pauseAnimation()
        return
      }

      // this.isPlaying = true
      // this.currentStep = 0 // 从第0个地点开始
      // this.currentFrame = 0 // 初始帧
      // this.activeIndex = 0 // 高亮起点
      // this.dynamicPath = [] // 清空动态路径

      // // 恢复初始缩放级别
      // this.map.setZoom(4)

      // if (this.dynamicPolyline) this.dynamicPolyline.setMap(null)
      // if (this.animateMarker) this.animateMarker.setMap(null)
      // this.markers.forEach(marker => marker.setMap(null))

      // // 2. 仅显示起点标记

      // // 1. 获取第一个地点坐标（动画起始点）
      // const startPoint = this.mapData[0]
      // // eslint-disable-next-line no-undef
      // const startLatLng = new qq.maps.LatLng(startPoint.property.didianzuobiao.lat, startPoint.property.didianzuobiao.lng)

      // // 2. 缩放到动画级别（zoom=4），并定位到第一个地点（修正核心）
      // this.map.setZoom(4)
      // this.map.setCenter(startLatLng) // 强制设置中心为第一个地点

      // // 3. 初始化动态轨迹线（空路径）
      // // eslint-disable-next-line no-undef
      // this.dynamicPolyline = new qq.maps.Polyline({
      //   path: this.dynamicPath,
      //   strokeColor: '#233A4F',
      //   strokeWeight: 2,
      //   strokeOpacity: 0.4,
      //   map: this.map
      // })

      // // eslint-disable-next-line no-undef
      // this.dynamicPath = [new qq.maps.LatLng(
      //   this.mapData[0].property.didianzuobiao.lat,
      //   this.mapData[0].property.didianzuobiao.lng
      // )] // 初始化动态路径

      // this.dynamicPolyline.setPath(this.dynamicPath)
      this.markers.forEach(marker => marker.setMap(null))
      // 开始动画
      this.map.setZoom(5)
      this.startAnimation()
    },

    /** 开始轨迹动画（恒定速度核心逻辑） */
    startAnimation() {
      this.clearAllTimers()
      // 重置绘制状态
      this.activeIndex = 0
      this.currentStep = 0
      this.isPlaying = true
      // 清除原有轨迹线
      if (this.polyline) this.polyline.remove()
      // 初始化轨迹线【优化：添加线样式，让轨迹更顺滑】
      // eslint-disable-next-line no-undef
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: [[this.mapData[0].property.didianzuobiao.lng, this.mapData[0].property.didianzuobiao.lat]],
        strokeColor: '#6b8e4e',
        strokeWeight: 3,
        strokeOpacity: 0.9,
        strokeLineCap: 'round', // 线帽圆角
        strokeLineJoin: 'round' // 线连接圆角
      })
      // 启动绘制
      this.drawTrackStep()
    },

    /** 暂停动画 */
    pauseAnimation() {
      this.clearAllTimers()
      this.isPlaying = false
    },

    /** 分步绘制轨迹【核心修复：轨迹线更新方式 + 提速】 */
    drawTrackStep() {
      // 所有点绘制完成
      if (this.activeIndex >= this.mapData.length - 1) {
        this.pauseAnimation()
        return
      }

      try {
        // 1. 获取当前绘制的两个点（起点/终点）
        const startPoint = this.mapData[this.activeIndex].property.didianzuobiao
        const endPoint = this.mapData[this.activeIndex + 1].property.didianzuobiao
        const start = [startPoint.lng, startPoint.lat]
        const end = [endPoint.lng, endPoint.lat]
        console.log('start', typeof start[0])
        console.log('end', end)
        // 2. 计算两点间的**实际地理距离（米）**（高德几何工具）
        // eslint-disable-next-line no-undef
        const totalDistance = AMap.GeometryUtil.distance(start, end)
        // 3. 动态计算插值总步数 = 总距离 ÷ 每帧移动距离（核心：距离越长步数越多）
        let totalSteps = Math.ceil(totalDistance / (this.baseStepDistance * this.speed))
        // 最小步数限制（避免两点过近时步数太少导致动画卡顿）
        totalSteps = Math.max(totalSteps, 8)

        // 4. 逐帧绘制（固定30ms间隔，每帧移动固定米数）
        this.frameTimer = setInterval(() => {
          this.currentStep++
          // 插值计算当前帧的经纬度（线性插值，保证轨迹直线）
          const currentLng = start[0] + (end[0] - start[0]) * (this.currentStep / totalSteps)
          const currentLat = start[1] + (end[1] - start[1]) * (this.currentStep / totalSteps)
          const currentPoint = [currentLng, currentLat]
          console.log('totalSteps', totalSteps)
          // 【核心修复：轨迹线更新】浅拷贝生成新数组，触发高德地图重绘
          const newPath = [...this.polyline.getPath()]
          newPath.push(currentPoint)
          this.polyline.setPath(newPath)

          // 镜头跟随（平滑移动到当前点）
          this.map.panTo(currentPoint)

          // 5. 当前两点绘制完成，切换到下一个点
          if (this.currentStep >= totalSteps) {
            this.clearAllTimers()
            this.currentStep = 0
            this.activeIndex++
            // 继续绘制下一段轨迹
            this.drawTrackStep()
          }
        }, 30)
      } catch (error) {
        console.log('error', error)
      }
    },

    /** 清理定时器（兜底） */
    clearAllTimers() {
      if (this.frameTimer) {
        clearInterval(this.frameTimer)
        this.frameTimer = null
      }
    },

    /**
     * 轨迹动画核心逻辑
     */
    startAnimate() {
      // eslint-disable-next-line no-undef
      if (!this.isPlaying || !qq || !qq.maps) {
        this.isPlaying = false
        return
      }

      // 播放完成
      if (this.currentStep >= this.mapData.length - 1) {
        this.isPlaying = false
        return
      }

      const startPoint = this.mapData[this.currentStep].property.didianzuobiao
      const endPoint = this.mapData[this.currentStep + 1].property.didianzuobiao
      // 动态计算stepCount（根据距离）
      const stepCount = this.getDynamicStepCount(
        startPoint.lat,
        startPoint.lng,
        endPoint.lat,
        endPoint.lng
      )
      // 根据速度调整步进数（速度越慢，步进数越多，越平滑）
      const stepLat = (endPoint.lat - startPoint.lat) / stepCount
      const stepLng = (endPoint.lng - startPoint.lng) / stepCount
      this.animateTimer = setInterval(() => {
        // 帧计数+1
        this.currentFrame++

        // 计算当前帧的位置
        const currentLat = startPoint.lat + stepLat * this.currentFrame
        const currentLng = startPoint.lng + stepLng * this.currentFrame
        // eslint-disable-next-line no-undef
        const currentPos = new qq.maps.LatLng(currentLat, currentLng)

        // 更新移动标记位置
        // this.animateMarker.setPosition(currentPos)

        // 镜头跟随动画移动、
        console.log('currentLng', currentLng)
        this.map.panTo(currentPos)

        // 更新动态轨迹线（添加当前帧位置）
        this.dynamicPath.push(currentPos)
        this.dynamicPolyline.setPath(this.dynamicPath)

        // 到达终点
        if (this.currentFrame >= stepCount) {
          clearInterval(this.animateTimer)
          this.currentStep++
          console.log('currentStep', this.currentStep)
          this.activeIndex = this.currentStep
          this.currentFrame = 0 // 重置帧计数
          this.activeIndex = this.currentStep // 高亮当前到达的点

          // 定位到当前点
          // eslint-disable-next-line no-undef
          this.map.panTo(new qq.maps.LatLng(endPoint.lat, endPoint.lng))

          // 继续下一段动画
          this.startAnimate()
        }
      }, this.animateSpeed)
    },

    /**
     * 计算两点之间的距离（米）
     */
    calculateDistance(lat1, lng1, lat2, lng2) {
      const R = 6371000 // 地球半径（米）
      const radLat1 = Math.PI * lat1 / 180
      const radLat2 = Math.PI * lat2 / 180
      const deltaLat = Math.PI * (lat2 - lat1) / 180
      const deltaLng = Math.PI * (lng2 - lng1) / 180

      // 哈弗辛公式
      const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
                Math.cos(radLat1) * Math.cos(radLat2) *
                Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return R * c // 距离（米）
    },

    prevMap() {
      if (this.activeIndex <= 0) return
      this.changeMap(this.activeIndex - 1)
    },

    nextMap() {
      if (this.activeIndex >= this.mapData.length - 1) return
      this.changeMap(this.activeIndex + 1)
    },

    /**
     * 根据距离计算动态stepCount（保证视觉速度一致）
     */
    getDynamicStepCount(startLat, startLng, endLat, endLng) {
      // eslint-disable-next-line no-undef
      if (!this.map || !qq) return 50

      // 1. 计算实际距离（米）
      const distance = this.calculateDistance(startLat, startLng, endLat, endLng)

      // 2. 将距离转换为地图像素（根据当前缩放级别）
      const startPoint = this.map.getProjection().fromLatLngToPoint(
        // eslint-disable-next-line no-undef
        new qq.maps.LatLng(startLat, startLng)
      )
      const endPoint = this.map.getProjection().fromLatLngToPoint(
        // eslint-disable-next-line no-undef
        new qq.maps.LatLng(endLat, endLng)
      )
      const pixelDistance = Math.sqrt(
        Math.pow(endPoint.x - startPoint.x, 2) +
        Math.pow(endPoint.y - startPoint.y, 2)
      )

      // 3. 根据基础步速计算stepCount（保证视觉速度一致）
      const stepCount = Math.max(Math.round(pixelDistance / this.baseStepSpeed), 10)
      console.log(`两点距离：${distance.toFixed(2)}米，像素距离：${pixelDistance.toFixed(2)}，stepCount：${stepCount}`)
      return stepCount
    },

    initMarkers() {
      this.mapData.forEach((item, index) => {
        // eslint-disable-next-line no-undef
        const marker = new qq.maps.Marker({
          // eslint-disable-next-line no-undef
          position: new qq.maps.LatLng(item.property.didianzuobiao.lat, item.property.didianzuobiao.lng),
          map: null, // 初始不显示
          title: item.property.event_summary,
          label: {
            content: `${index + 1}`,
            color: '#fff',
            fontSize: '12px'
          }
        })
        const that = this
        // eslint-disable-next-line no-undef
        qq.maps.event.addListener(marker, 'click', () => {
          // 获取标记点相对于屏幕的位置
          const markerLatLng = item.property.didianzuobiao
          // eslint-disable-next-line no-undef
          const latLng = new qq.maps.LatLng(markerLatLng.lat, markerLatLng.lng)

          // 存储当前标记的所有数据信息
          const markerData = {
            index: index, // 标记索引
            data: { ...item } // 标记原始数据（深拷贝）
          }
          // 4. 可选：执行其他业务逻辑
          that.handleMarkerClick(markerData)
          that.openInfoWindow(markerData, latLng)
        })
        this.markers.push(marker)
      })
    },

    openInfoWindow(markerData, latLng) {
      const projection = this.map.getProjection()
      const point = projection.fromLatLngToPoint(latLng)

      const scale = Math.pow(2, this.map.getZoom())
      const pixelX = point.x * scale
      const pixelY = point.y * scale

      const mapRect = document.getElementById('tecenmap').getBoundingClientRect()
      this.infoWindowX = mapRect.left + pixelX + 20 // 右侧偏移
      this.infoWindowY = mapRect.top + pixelY - 80 // 上方偏移
      console.log('infoWindowX', this.infoWindowX, 'infoWindowY', this.infoWindowY)
      this.currentMarkerData = markerData
      this.infoWindowVisible = true
    },

    handleMarkerClick(v) {
      // console.log('v', v)
      // const page = this.$router.resolve({
      //   path: '/entity',
      //   query: {
      //     cateId: '013003',
      //     sourceId: v.data.id
      //   }
      // })
      // window.open(page.href, '_blank')
    },

    changeMap(index) {
      this.activeIndex = index
      // 清除所有已显示的标记
      this.markers.forEach(marker => {
        marker.setMap(null)
      })

      if (this.polyline) this.polyline.setMap(null)
      // 显示当前点击的标记
      const currentMarker = this.markers[index]
      currentMarker.setMap(this.map)
      this.map.panTo([this.mapData[index].property.didianzuobiao.lng, this.mapData[index].property.didianzuobiao.lat])
      this.map.setZoom(9)
    },

    /**
     * 重置轨迹
     */
    resetTrack() {
      this.pauseTrack()
      // 1. 重置所有状态
      this.activeIndex = -1
      this.currentStep = 0
      this.currentFrame = 0
      this.dynamicPath = []

      // 2. 清除所有标记和轨迹
      if (this.animateMarker) this.animateMarker.setMap(null)
      if (this.dynamicPolyline) this.dynamicPolyline.setMap(null)
      this.markers.forEach(marker => marker.setMap(null))

      // 3. 回到地图起点
      // eslint-disable-next-line no-undef
      if (this.map && qq && qq.maps) {
        // eslint-disable-next-line no-undef
        this.map.panTo(new qq.maps.LatLng(
          this.locationList[0].lat,
          this.locationList[0].lng
        ))
      }
    },
    /**
     * 暂停轨迹播放
     */
    pauseTrack() {
      this.clearAllTimers()
      this.isPlaying = false
    },
    previewImage(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.map-page {
  width: 100%;
  height: 100%;
  // background: $color-paper-light;

  .map-page-body {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .map-page-body-inner {
    height: 100%;
  }

  .map-page-body-content {
    width: 100%;
    height: 100%;
    background: $color-paper-light;
  }

  .map-page-body-content-tool {
    position: absolute;
    top: $spacing-2xl;
    right: $content-padding;
    width: 400px;
    max-width: calc(100% - #{$content-padding * 2});
    height: calc(100% - #{$spacing-4xl});
    z-index: 8;

    &.left {
      left: $content-padding;
      right: auto;
    }

    &__card {
      width: 100%;
      height: calc(100% - 56px);
      background: $color-white;
      border-radius: 4px;
      border: 1px solid rgba($color-border, 0.45);
      box-shadow: 0 4px 24px rgba($color-brown-dark, 0.1);
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .head {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: $spacing-sm;
        min-height: 56px;
        padding: $spacing-md $spacing-base;
        border-bottom: 1px solid rgba($color-border, 0.45);

        .tit {
          margin: 0;
          font-family: $font-serif;
          font-size: rem(18);
          font-weight: 700;
          color: $color-brown-dark;
          letter-spacing: 1px;
        }

        .tail {
          display: flex;
          align-items: center;
          gap: $spacing-md;

          .item {
            display: flex;
            align-items: center;
            gap: $spacing-xs;

            img {
              width: 16px;
              height: 16px;
              flex-shrink: 0;
            }

            p {
              margin: 0;
              font-size: rem(12);
              color: $color-text-light;
              white-space: nowrap;
            }
          }
        }
      }

      .list {
        flex: 1;
        overflow-x: hidden;
        overflow-y: auto;
        width: 100%;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-thumb {
          background: rgba($color-border, 0.8);
          border-radius: 3px;
        }

        .list__item {
          padding: $spacing-base;
          border-bottom: 1px solid rgba($color-border, 0.35);
          cursor: pointer;
          transition: background-color 0.2s ease;

          .date {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: $spacing-sm;

            p {
              margin: 0;
              font-size: rem(13);
              font-weight: 600;
              color: $color-brown-dark;
              line-height: 1.5;
            }
          }

          .title {
            margin: $spacing-sm 0 0;
            font-family: $font-serif;
            font-size: rem(15);
            font-weight: 700;
            color: $color-text;
            line-height: 1.6;
          }

          .types {
            display: flex;
            align-items: flex-start;
            gap: $spacing-sm;
            margin-top: $spacing-sm;

            .item {
              display: flex;
              align-items: flex-start;
              gap: $spacing-xs;
              flex: 1;
              min-width: 0;

              img {
                width: 14px;
                height: 14px;
                margin-top: 2px;
                flex-shrink: 0;
              }

              p {
                margin: 0;
                font-size: rem(12);
                color: $color-text-light;
                line-height: 1.5;
              }
            }
          }

          .imgs {
            display: flex;
            flex-wrap: wrap;
            gap: $spacing-sm;
            margin-top: $spacing-sm;

            img {
              width: 96px;
              height: 64px;
              border-radius: 4px;
              object-fit: cover;
              cursor: pointer;
              filter: grayscale(0.25) sepia(0.1);
              border: 1px solid rgba($color-border, 0.35);
            }
          }

          &:hover,
          &.active {
            background: $color-cream;
            position: relative;

            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 3px;
              height: 100%;
              background: $success-color;
            }
          }
        }
      }
    }

    &__buttons {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: $spacing-sm;
      margin-top: $spacing-base;
      height: 40px;

      .btn {
        flex: 1;
        height: 40px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: $spacing-xs;
        background: $color-white;
        border: 1px solid rgba($color-border, 0.55);
        cursor: pointer;
        transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

        img {
          width: 16px;
          height: 16px;
        }

        p {
          margin: 0;
          font-size: rem(13);
          color: $color-text;
        }

        &.last {
          flex-direction: row-reverse;
        }

        &:hover,
        &.active {
          background: $color-brown-dark;
          border-color: $color-brown-dark;

          p {
            color: $color-white;
          }

          img {
            filter: brightness(0) invert(1);
          }
        }

        &.play img {
          filter: none;
        }

        &.play:hover img,
        &.play.active img {
          filter: brightness(0) invert(1);
        }
      }
    }
  }

  .error {
    width: 100%;
    min-height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $color-white;
    border-radius: 4px;
    border: 1px solid rgba($color-border, 0.4);

    p {
      margin: 0;
      font-size: rem(14);
      color: $color-text-light;
    }
  }
}

.text-line-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-info-window {
  position: fixed;
  width: 240px;
  background: $color-white;
  border: 1px solid rgba($color-border, 0.55);
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba($color-brown-dark, 0.12);
  z-index: 1000;
  overflow: hidden;
}

.info-header {
  background: $color-brown-dark;
  color: $color-white;
  padding: $spacing-sm $spacing-md;
  font-family: $font-serif;
  font-size: rem(14);
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  background: none;
  border: none;
  color: $color-white;
  font-size: rem(16);
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

.info-body {
  padding: $spacing-md;
  font-size: rem(13);
  color: $color-text-light;
  line-height: 1.6;

  p {
    margin: $spacing-xs 0;
  }
}

@media (max-width: 960px) {
  .map-page .map-page-body-content-tool {
    position: static;
    width: 100%;
    max-width: none;
    height: auto;
    margin-top: $spacing-base;

    &__card {
      height: 360px;
    }
  }
}
</style>
